var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading || _vm.isLoggedIn == -1)?_c('loading'):_vm._e(),(_vm.isLoggedIn == 1)?_c('whats-redirect'):(_vm.isLoggedIn == 0)?_c('auth'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }